/* ─────────────────────────────────────────────────────────────
   AdminImportExcel — atajo desde el Hub para que admin (octavio)
   suba el Excel CRC sin pasar por el módulo Capturista completo.

   Reutiliza ImportExcelTab del módulo Capturista (misma lógica de
   parseo, omisión de duplicados por folio y cálculo de zona).
   ───────────────────────────────────────────────────────────── */
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../auth/AuthContext";
import { ImportExcelTab } from "./CapturistaModule";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminImportExcel() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  const cargarStats = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/capturista/stats`);
      setStats(r.data);
    } catch {
      setStats(null);
    }
  }, []);

  useEffect(() => { cargarStats(); }, [cargarStats]);

  return (
    <div className="hub-bg" data-testid="page-admin-import-excel">
      <header className="topnav">
        <div className="brand">
          <button onClick={() => navigate("/hub")} className="iconbtn mr-1" aria-label="Atrás" data-testid="btn-back-hub-import">
            <i className="fa-solid fa-arrow-left"/>
          </button>
          <div className="logo" style={{ background: "#10B981" }}>
            <i className="fa-solid fa-file-excel"/>
          </div>
          <div>
            <div className="title">Importar Excel CRC</div>
            <div className="sub">Atajo Admin · Importación masiva desde el portal CRC</div>
          </div>
        </div>
        <div className="actions">
          <div className="hidden sm:block text-right mr-2">
            <div className="text-sm font-semibold leading-tight">{user?.nombre}</div>
            <div className="text-xs text-slate-500">{user?.rol}</div>
          </div>
          <button onClick={logout} className="btn-ghost" data-testid="btn-logout-admin-import" style={{ padding: "0.5rem 0.9rem" }}>
            <i className="fa-solid fa-right-from-bracket mr-1"/>Salir
          </button>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 py-6">
        <ImportExcelTab onImported={cargarStats} stats={stats}/>
      </main>
    </div>
  );
}
